import { Alert, Tooltip, Stack, Typography, Link, Box } from '@mui/material';
import { useAuthContext } from '../../auth/useAuthContext';
import LoginLayout from '../../layouts/login';

export default function Login() {
  const { method } = useAuthContext();

  return (
    <LoginLayout>
      <Stack spacing={2} sx={{ mb: 5, position: 'relative' }}>
        <Typography variant="h4">Вхід для суддів</Typography>
      </Stack>
    </LoginLayout>
  );
}
